/* eslint-disable react/display-name */
import React from "react";
import PropTypes from "prop-types";

import ReactTable from "react-table";
import { DropdownButton, NavItem } from "react-bootstrap";
import { IoFolder, IoTrash, IoEllipsisVertical } from "react-icons/io5";

const RoleList = ({ roles, onClickEdit, onClickDelete }) => {
  const columns = [
    {
      Header: "Number",
      accessor: "number",
      maxWidth: 200
    },
    {
      Header: "Name",
      accessor: "name"
    },
    {
      Header: "",
      accessor: "_id",
      maxWidth: 80,
      Cell: (row) => (
        <div className="text-center actions">
          <DropdownButton
            title={
              <span>
                <IoEllipsisVertical />
              </span>
            }
            id="dropdown"
          >
            <NavItem onClick={() => onClickEdit(row.value)}>
              <IoFolder />
              View
            </NavItem>
            <NavItem onClick={() => onClickDelete(row.value)}>
              <IoTrash />
              Delete
            </NavItem>
          </DropdownButton>
        </div>
      )
    }
  ];

  return (
    <ReactTable
      className="-highlight"
      data={roles}
      loading={false}
      columns={columns}
      minRows={0}
      pageSize={roles.length || 1}
      showPagination={false}
      sorted={[
        {
          id: "number",
          desc: true
        }
      ]}
    />
  );
};

RoleList.propTypes = {
  roles: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      number: PropTypes.number.isRequired
    }).isRequired
  ).isRequired,
  onClickEdit: PropTypes.func.isRequired,
  onClickDelete: PropTypes.func.isRequired
};

export default RoleList;
